export default __webpack_public_path__ + "fonts/CiscoSansLight-webfont.eot";